'use strict';

/**
 * @ngdoc component
 * @name mx.shell:mxShellAvatar
 * @module mx.shell
 * @description A combination of user's name, surname and avatar picture
 * @param {string} name= - User's name
 * @param {string} surname= - User's surname
 * @param {string} photo= - An url to user's photo/avatar
 * @usage <mx-shell-avatar name="vm.firstName" surname="vm.lastName" photo="vm.avatarUrl"></mx-shell-avatar>
 */

angular.module('mx.shell').component('mxShellAvatar', {
	bindings: {
		photo: '<',
		name: '<',
		surname: '<',
	},
	controller: MxShellAvatarCtrl,
	controllerAs: 'vm',
	templateUrl: 'components/mx-shell-avatar/mx-shell-avatar.html',
});

MxShellAvatarCtrl.$inject = ['$scope', 'mx.app.ColorService', 'mx.app.ThemeService'];

function MxShellAvatarCtrl($scope, colorService, themeService) {
	const vm = this;

	themeService.getCurrentTheme().then((currentTheme) => {
		vm.isDark = colorService.getLightness(currentTheme['header-bg-color']) <= colorService.getLightness(currentTheme['header-icon-color']);
	});

	function getPhotoUrl(photo) {
		if (!photo || photo.toLowerCase().includes('/emptyuser')) {
			return '';
		}

		const url = photo.split('"').join('\\"');
		return `url("${url}")`;
	}

	$scope.$watch('vm.photo', function (photo) {
		vm.photoCss = getPhotoUrl(photo);
		vm.alternativeAbbreviation = vm.photoCss ? '' : (((vm.name && vm.name[0]) || '') + ((vm.surname && vm.surname[0]) || '')).toUpperCase();
	});
}
